import { Control, ControlItemValue, StaticControlItem } from '../types/types';

// First option of a radioBtn/combobox control; undefined for controls without
// a static option list.
export const getFirstControlOptionValue = (
  control: Control | undefined
): ControlItemValue | undefined => {
  if (!control || !('items' in control) || !Array.isArray(control.items)) {
    return undefined;
  }

  const options = control.items as StaticControlItem[];

  return options.length > 0 ? options[0].value : undefined;
};
